<script lang="ts">
  import MainLayout from "../../layout/MainLayout.svelte";
</script>

<MainLayout>
  <h2>Pagina non trovata!</h2>
</MainLayout>
